import { atom } from 'jotai';

export type LandingVariant = 'android' | 'ios' | 'ios26';

export const landingVariantAtom = atom<LandingVariant>('ios');
